
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12">
                <img 
                  src="https://static.readdy.ai/image/63d87af7a40bfd4e1fb84bf1f2e1a460/e6815bf4d9ae56d68cde10abb437e28d.png" 
                  alt="NextZen Soccer Academy Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-white leading-none">
                  NEXTZEN
                </span>
                <span className="text-xs text-purple-400 font-medium tracking-wide">
                  SOCCER ACADEMY
                </span>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md text-lg font-medium">
              Next Up. Next Level. NextZen.
            </p>
            <p className="text-gray-400 mb-6 max-w-md">
              Developing young soccer talents through professional coaching, character building, and a passion for the beautiful game in Folsom, CA.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-twitter-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/programs" className="text-gray-300 hover:text-white cursor-pointer">Programs</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white cursor-pointer">About Us</Link></li>
              <li><Link to="/sessions" className="text-gray-300 hover:text-white cursor-pointer">Session Times</Link></li>
              <li><Link to="/register" className="text-gray-300 hover:text-white cursor-pointer">Register</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white cursor-pointer">Blog</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-green-400"></i>
                <span className="text-gray-300">Folsom, CA</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-400"></i>
                <span className="text-gray-300">(916) 555-KICK</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-green-400"></i>
                <span className="text-gray-300">info@nextzensoccer.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 NextZen Soccer Academy. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}